import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';

import { RouteRefreshService } from './route-refresh.service';

export const provideDataRefresh = () => runOnSportsWebInit(RouteRefreshService);
